import { Controller } from "@hotwired/stimulus"

export default class DatePickerController extends Controller {
  static targets = ["input"]

  showPicker() {
    this.inputTarget.showPicker()
  }
}
